// @generated by protobuf-ts 2.9.4 with parameter optimize_code_size,long_type_number,generate_dependencies
// @generated from protobuf file "Protos/unlocks.proto" (package "wuxiaworld.api.v2", syntax proto3)
// tslint:disable
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../google/protobuf/timestamp";
import { Any } from "../google/protobuf/any";
import { PageInfoResponse } from "./pagination";
import { PageInfoRequest } from "./pagination";
/**
 * @generated from protobuf message wuxiaworld.api.v2.GetUnlocksRequest
 */
export interface GetUnlocksRequest {
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.UnlockItemType type = 1;
     */
    type: UnlockItemType;
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.PageInfoRequest pageInfo = 2;
     */
    pageInfo?: PageInfoRequest;
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.GetUnlocksRequest.FilterUnlocks filter = 3;
     */
    filter?: GetUnlocksRequest_FilterUnlocks;
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.GetUnlocksRequest.FilterUnlocks
 */
export interface GetUnlocksRequest_FilterUnlocks {
    /**
     * @generated from protobuf oneof: id
     */
    id: {
        oneofKind: "novelId";
        /**
         * @generated from protobuf field: int32 novelId = 1;
         */
        novelId: number;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.GetUnlocksResponse
 */
export interface GetUnlocksResponse {
    /**
     * @generated from protobuf field: repeated wuxiaworld.api.v2.UnlockedItem items = 1;
     */
    items: UnlockedItem[];
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.PageInfoResponse pageInfo = 2;
     */
    pageInfo?: PageInfoResponse;
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.UnlockItemRequest
 */
export interface UnlockItemRequest {
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.UnlockItemMethod unlockMethod = 1;
     */
    unlockMethod: UnlockItemMethod;
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.UnlockedItem item = 2;
     */
    item?: UnlockedItem;
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.UnlockItemResponse
 */
export interface UnlockItemResponse {
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.UnlockedItem unlockedItem = 1;
     */
    unlockedItem?: UnlockedItem;
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.BatchUnlockItemsRequest
 */
export interface BatchUnlockItemsRequest {
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.UnlockItemMethod unlockMethod = 1;
     */
    unlockMethod: UnlockItemMethod;
    /**
     * @generated from protobuf field: repeated wuxiaworld.api.v2.UnlockedItem items = 2;
     */
    items: UnlockedItem[];
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.BatchUnlockItemsResponse
 */
export interface BatchUnlockItemsResponse {
    /**
     * @generated from protobuf field: repeated wuxiaworld.api.v2.UnlockedItem unlockedItems = 1;
     */
    unlockedItems: UnlockedItem[];
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.UnlockedItem
 */
export interface UnlockedItem {
    /**
     * @generated from protobuf field: google.protobuf.Any item = 1;
     */
    item?: Any;
    /**
     * @generated from protobuf oneof: id
     */
    id: {
        oneofKind: "chapterId";
        /**
         * @generated from protobuf field: int32 chapterId = 2;
         */
        chapterId: number;
    } | {
        oneofKind: "novelId";
        /**
         * @generated from protobuf field: int32 novelId = 3;
         */
        novelId: number;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: google.protobuf.Timestamp unlockedAt = 4;
     */
    unlockedAt?: Timestamp;
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.UnlockItemMethod unlockMethod = 5;
     */
    unlockMethod: UnlockItemMethod;
}
/**
 * @generated from protobuf enum wuxiaworld.api.v2.UnlockItemType
 */
export enum UnlockItemType {
    /**
     * @generated from protobuf enum value: UnlockItemNone = 0;
     */
    UnlockItemNone = 0,
    /**
     * @generated from protobuf enum value: UnlockItemChapter = 1;
     */
    UnlockItemChapter = 1,
    /**
     * @generated from protobuf enum value: UnlockItemNovel = 2;
     */
    UnlockItemNovel = 2
}
/**
 * @generated from protobuf enum wuxiaworld.api.v2.UnlockItemMethod
 */
export enum UnlockItemMethod {
    /**
     * @generated from protobuf enum value: UnlockMethodNone = 0;
     */
    UnlockMethodNone = 0,
    /**
     * @generated from protobuf enum value: UnlockMethodKarma = 1;
     */
    UnlockMethodKarma = 1,
    /**
     * @generated from protobuf enum value: UnlockMethodVip = 2;
     */
    UnlockMethodVip = 2,
    /**
     * @generated from protobuf enum value: UnlockMethodSponsor = 3;
     */
    UnlockMethodSponsor = 3,
    /**
     * @generated from protobuf enum value: UnlockMethodWtu = 4;
     */
    UnlockMethodWtu = 4,
    /**
     * @generated from protobuf enum value: UnlockMethodVoucher = 5;
     */
    UnlockMethodVoucher = 5
}
// @generated message type with reflection information, may provide speed optimized methods
class GetUnlocksRequest$Type extends MessageType<GetUnlocksRequest> {
    constructor() {
        super("wuxiaworld.api.v2.GetUnlocksRequest", [
            { no: 1, name: "type", kind: "enum", T: () => ["wuxiaworld.api.v2.UnlockItemType", UnlockItemType] },
            { no: 2, name: "pageInfo", kind: "message", T: () => PageInfoRequest },
            { no: 3, name: "filter", kind: "message", T: () => GetUnlocksRequest_FilterUnlocks }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.GetUnlocksRequest
 */
export const GetUnlocksRequest = new GetUnlocksRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUnlocksRequest_FilterUnlocks$Type extends MessageType<GetUnlocksRequest_FilterUnlocks> {
    constructor() {
        super("wuxiaworld.api.v2.GetUnlocksRequest.FilterUnlocks", [
            { no: 1, name: "novelId", kind: "scalar", oneof: "id", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.GetUnlocksRequest.FilterUnlocks
 */
export const GetUnlocksRequest_FilterUnlocks = new GetUnlocksRequest_FilterUnlocks$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUnlocksResponse$Type extends MessageType<GetUnlocksResponse> {
    constructor() {
        super("wuxiaworld.api.v2.GetUnlocksResponse", [
            { no: 1, name: "items", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => UnlockedItem },
            { no: 2, name: "pageInfo", kind: "message", T: () => PageInfoResponse }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.GetUnlocksResponse
 */
export const GetUnlocksResponse = new GetUnlocksResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UnlockItemRequest$Type extends MessageType<UnlockItemRequest> {
    constructor() {
        super("wuxiaworld.api.v2.UnlockItemRequest", [
            { no: 1, name: "unlockMethod", kind: "enum", T: () => ["wuxiaworld.api.v2.UnlockItemMethod", UnlockItemMethod] },
            { no: 2, name: "item", kind: "message", T: () => UnlockedItem }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.UnlockItemRequest
 */
export const UnlockItemRequest = new UnlockItemRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UnlockItemResponse$Type extends MessageType<UnlockItemResponse> {
    constructor() {
        super("wuxiaworld.api.v2.UnlockItemResponse", [
            { no: 1, name: "unlockedItem", kind: "message", T: () => UnlockedItem }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.UnlockItemResponse
 */
export const UnlockItemResponse = new UnlockItemResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BatchUnlockItemsRequest$Type extends MessageType<BatchUnlockItemsRequest> {
    constructor() {
        super("wuxiaworld.api.v2.BatchUnlockItemsRequest", [
            { no: 1, name: "unlockMethod", kind: "enum", T: () => ["wuxiaworld.api.v2.UnlockItemMethod", UnlockItemMethod] },
            { no: 2, name: "items", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => UnlockedItem }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.BatchUnlockItemsRequest
 */
export const BatchUnlockItemsRequest = new BatchUnlockItemsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BatchUnlockItemsResponse$Type extends MessageType<BatchUnlockItemsResponse> {
    constructor() {
        super("wuxiaworld.api.v2.BatchUnlockItemsResponse", [
            { no: 1, name: "unlockedItems", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => UnlockedItem }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.BatchUnlockItemsResponse
 */
export const BatchUnlockItemsResponse = new BatchUnlockItemsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UnlockedItem$Type extends MessageType<UnlockedItem> {
    constructor() {
        super("wuxiaworld.api.v2.UnlockedItem", [
            { no: 1, name: "item", kind: "message", T: () => Any },
            { no: 2, name: "chapterId", kind: "scalar", oneof: "id", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "novelId", kind: "scalar", oneof: "id", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "unlockedAt", kind: "message", T: () => Timestamp },
            { no: 5, name: "unlockMethod", kind: "enum", T: () => ["wuxiaworld.api.v2.UnlockItemMethod", UnlockItemMethod] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.UnlockedItem
 */
export const UnlockedItem = new UnlockedItem$Type();
/**
 * @generated ServiceType for protobuf service wuxiaworld.api.v2.Unlocks
 */
export const Unlocks = new ServiceType("wuxiaworld.api.v2.Unlocks", [
    { name: "GetUnlocks", options: {}, I: GetUnlocksRequest, O: GetUnlocksResponse },
    { name: "UnlockItem", options: {}, I: UnlockItemRequest, O: UnlockItemResponse },
    { name: "BatchUnlockItems", options: {}, I: BatchUnlockItemsRequest, O: BatchUnlockItemsResponse }
]);
